import React from "react";
import { Typography } from "antd";
import { SECTION_GAP } from "./constants";

const { Title } = Typography;

interface PageSectionProps {
  /** Optional section-level heading rendered above the cards */
  title?: string;
  children: React.ReactNode;
}

/**
 * Vertical stack of SectionCards with consistent spacing.
 * Use inside PageLayout to group related SectionCards.
 */
const PageSection: React.FC<PageSectionProps> = ({ title, children }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: SECTION_GAP }}>
    {title && (
      <Title level={5} style={{ margin: 0, fontSize: 13, fontWeight: 600 }}>
        {title}
      </Title>
    )}
    {children}
  </div>
);

export default PageSection;
